import React, {useState} from "react";
import {Modal, Button, Form} from "react-bootstrap";
import {submitContactUs} from "../services/adminServices";
import {sweetAlerts} from "../utils/sweet-alerts";

const ContactUsModal = ({show, handleClose, titleModal}) => {
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		email: "",
		phone: "",
		message: "",
	});
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);

	const handleChange = (e) => {
		const {name, value} = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
		// Clear error when user starts typing
		if (errors[name]) {
			setErrors((prev) => ({
				...prev,
				[name]: "",
			}));
		}
	};

	const validate = () => {
		const newErrors = {};

		if (!formData.firstName.trim()) {
			newErrors.firstName = "First name is required";
		}

		if (!formData.lastName.trim()) {
			newErrors.lastName = "Last name is required";
		}

		if (!formData.email.trim()) {
			newErrors.email = "Email is required";
		} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
			newErrors.email = "Please enter a valid email address";
		}

		if (!formData.message.trim()) {
			newErrors.message = "Message is required";
		} else if (formData.message.trim().length < 10) {
			newErrors.message = "Message must be at least 10 characters";
		}

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!validate()) {
			return;
		}

		setLoading(true);
		try {
			const response = await submitContactUs(formData);

			console.log(response, "response response response");

			if (response && response.status) {
				sweetAlerts("success", "Your message has been sent successfully. We will get back to you soon!");
				// Reset form
				setFormData({
					firstName: "",
					lastName: "",
					email: "",
					phone: "",
					message: "",
				});
				handleClose();
			} else {
				sweetAlerts("error", "Failed to send message. Please try again.");
			}
		} catch (error) {
			console.error("Error submitting contact form:", error);
			sweetAlerts("error", "Failed to send message. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	const handleCloseModal = () => {
		if (!loading) {
			setFormData({
				firstName: "",
				lastName: "",
				email: "",
				phone: "",
				message: "",
			});
			setErrors({});
			handleClose();
		}
	};

	return (
		<Modal show={show} onHide={handleCloseModal} centered className="contact-us-modal">
			<Modal.Header closeButton className="border-0 pb-0">
				<Modal.Title className="w-100 text-center">
					<img src={`${process.env.PUBLIC_URL}/img/header-logo.png`} alt="JobSite Rating" style={{maxHeight: "60px"}} />
					<h4 className="mt-3 mb-0">{titleModal}</h4>
					<p className="text-muted small mb-0">We'd love to hear from you!</p>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="px-4 pb-4">
				<Form onSubmit={handleSubmit}>
					<div className="row">
						<div className="col-md-6">
							<Form.Group className="mb-3">
								<Form.Label>
									First Name <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									type="text"
									name="firstName"
									placeholder="Enter your first name"
									value={formData.firstName}
									onChange={handleChange}
									className={errors.firstName ? "is-invalid" : ""}
									disabled={loading}
								/>
								{errors.firstName && <Form.Text className="text-danger">{errors.firstName}</Form.Text>}
							</Form.Group>
						</div>
						<div className="col-md-6">
							<Form.Group className="mb-3">
								<Form.Label>
									Last Name <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									type="text"
									name="lastName"
									placeholder="Enter your last name"
									value={formData.lastName}
									onChange={handleChange}
									className={errors.lastName ? "is-invalid" : ""}
									disabled={loading}
								/>
								{errors.lastName && <Form.Text className="text-danger">{errors.lastName}</Form.Text>}
							</Form.Group>
						</div>
					</div>

					<Form.Group className="mb-3">
						<Form.Label>
							Email <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control type="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} className={errors.email ? "is-invalid" : ""} disabled={loading} />
						{errors.email && <Form.Text className="text-danger">{errors.email}</Form.Text>}
					</Form.Group>

					<Form.Group className="mb-3">
						<Form.Label>Phone Number</Form.Label>
						<Form.Control type="tel" name="phone" placeholder="Enter your phone number (optional)" value={formData.phone} onChange={handleChange} disabled={loading} />
					</Form.Group>

					<Form.Group className="mb-4">
						<Form.Label>
							Message <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							as="textarea"
							rows={5}
							name="message"
							placeholder="Tell us how we can help you..."
							value={formData.message}
							onChange={handleChange}
							className={errors.message ? "is-invalid" : ""}
							disabled={loading}
						/>
						{errors.message && <Form.Text className="text-danger">{errors.message}</Form.Text>}
					</Form.Group>

					<div className="d-flex gap-2">
						<Button variant="secondary" onClick={handleCloseModal} disabled={loading} className="flex-fill">
							Cancel
						</Button>
						<Button type="submit" className="btn-custom-green flex-fill" disabled={loading}>
							{loading ? "Sending..." : "Send Message"}
						</Button>
					</div>
				</Form>
			</Modal.Body>
		</Modal>
	);
};

export default ContactUsModal;
